import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FaExclamationTriangle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { brandName } from '../../constants/appConfig';

const UnauthorizedAccess = ({ color, className, message, paddingTop }) => (
  <div className={className}>
    <div
      className={classNames({
        'pt-0': (paddingTop === 0),
        'pt-12': (paddingTop === 12),
      })}
    >
      <div className={`flex flex-col justify-center align-center text-center text-${color}`}>
        <div className="text-center flex justify-center items-center">
          <FaExclamationTriangle className={`w-8 h-8 text-${color}`} />
        </div>

        <p className="mt-5">{message}</p>

        <p className="mt-5">
          <Link to="/" className="text-blue-500 hover:text-blue-600">Go to {brandName} Home</Link>
        </p>
      </div>
    </div>
  </div>
);

UnauthorizedAccess.defaultProps = {
  className: '',
  color: 'red-500',
  message: 'You are not authorized to access this page.',
  paddingTop: 12,
};

UnauthorizedAccess.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  message: PropTypes.string,
  paddingTop: PropTypes.number,
};

export default UnauthorizedAccess;
